import Footer from "@/components/Footer"
import PublicLayout from "@/components/Layout/Public"
import Logo from "@/components/Logo"
import RichText from "@/components/RichText"
import { Link, Head } from "@inertiajs/react"
import { ReactNode } from "react"

const Page = ({ page }) => (
  <>
    <Head title={page.title} />
    <div className="container w-full max-w-2xl px-6 py-10 mx-auto">
      <header className="flex items-center justify-center mb-10">
        <Link href="/">
          <Logo />
        </Link>
      </header>
      <h1 className="mb-10 text-2xl font-bold">{page.title}</h1>
      <RichText content={page.body} />
      <Footer />
    </div>
  </>
)

Page.layout = (page: ReactNode) => <PublicLayout children={page} />

export default Page
